import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { Link as RouterLink } from 'react-router-dom';

export interface ActionsColumnOptions<Row = any> {
  headerName?: string;
  width?: number;
  showView?: boolean;
  showEdit?: boolean;
  /** Build view URL from row */
  getViewUrl?: (row: Row) => string;
  /** Build edit URL from row */
  getEditUrl?: (row: Row) => string;
  /** Determine if edit should be shown for this row */
  shouldShowEdit?: (row: Row) => boolean;
  /** Space between icons in px */
  iconGapPx?: number;
}

export const createActionsColumn = <Row = any>(opts: ActionsColumnOptions<Row>): GridColDef => {
  const {
    headerName = 'Actions',
    width = 120,
    showView = false,
    showEdit = false,
    getViewUrl,
    getEditUrl,
    shouldShowEdit,
    iconGapPx = 16,
  } = opts;

  return {
    field: 'actions',
    headerName,
    width,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params: GridRenderCellParams<Row>) => {
      const viewUrl = getViewUrl ? getViewUrl(params.row) : '';
      const editUrl = getEditUrl ? getEditUrl(params.row) : '';
      const showEditForRow = shouldShowEdit ? shouldShowEdit(params.row) : showEdit;

      // If neither is requested, render empty cell to avoid layout shift
      if (!showView && !showEditForRow) {
        return <div />;
      }

      return (
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          {showView && viewUrl && (
            <RouterLink to={viewUrl} style={{ display: 'inline-flex', alignItems: 'center' }}>
              <VisibilityIcon fontSize="small" />
            </RouterLink>
          )}
          {showEditForRow && editUrl && (
            <RouterLink to={editUrl} style={{ display: 'inline-flex', alignItems: 'center', marginLeft: `${iconGapPx}px` }}>
              <EditIcon fontSize="small" />
            </RouterLink>
          )}
        </div>
      );
    },
  };
};

export default createActionsColumn;
